import { toCurrency } from '@utils/number';

import i18n from '@plugins/i18n';

import { ActivityCollection, Activity } from '@/models';

export class ActivityInvestorFlowCollection extends ActivityCollection {
    static type = 'ActivityInvestorFlowCollection';
    static endpoint = Activity.api.investorFlow;

    get default_headers() {
        return ['last_updated', 'activity', 'investor_id', 'proposal_id', 'created_by_id', 'created_by_email'];
    }

    get pdf_headers() {
        return ['last_updated', 'title', 'text', 'investor_id', 'proposal_id', 'created_by_id', 'created_by_email'];
    }

    get headers() {
        return [
            this.createHeader('last_updated', i18n.t('date'), {
                width: '9rem',
                filterable: true,
                sortable: true,
                format: 'datetime',
                formatOptions: {
                    showTime: true
                }
            }),
            this.createHeader('activity', i18n.t('activity'), {
                width: '35rem',
                filterable: false,
                sortable: false
            }),
            this.createHeader('title', i18n.t('activity'), {
                width: '12rem',
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/ActivityTitle.vue'),
                    options: {
                        type: 'flow'
                    }
                }
            }),
            this.createHeader('text', i18n.t('text'), {
                width: '38rem',
                filterable: true
            }),
            this.createHeader('investor_id', i18n.t('investor'), {
                width: '14rem',
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/Investor.vue')
                },
                transform: data => data.item?.investor?.name,
                to: data => {
                    const investorId = data.item?.investor?.id;

                    if (!investorId) return null;

                    return {
                        name: 'SettingsProfile',
                        query: { organisation_id: investorId, organisation_type: 'investor' }
                    };
                }
            }),
            this.createHeader('proposal_id', i18n.t('proposal'), {
                width: '14rem',
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/Proposal.vue')
                },
                transform: data => {
                    let name = [];

                    if (data.item?.proposal?.offer?.name) {
                        name.push(data.item?.proposal?.offer?.name);
                    }

                    if (data.item?.proposal?.amount?.amount) {
                        name.push(toCurrency(data.item.proposal.amount.amount, data.item.proposal.amount.currency));
                    }

                    name = name.join(' - ');

                    return name ? name : null;
                },
                to: data => {
                    const proposalId = data.item?.proposal?.id;

                    if (!proposalId) return null;

                    return {
                        name: 'Proposals',
                        query: { proposal: proposalId }
                    };
                }
            }),
            this.createHeader('created_by_id', i18n.t('user'), {
                width: '14rem',
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/User.vue')
                },
                transform: data => data.item?.created_by?.name,
                fallback: i18n.t('system'),
                formatOptions: {
                    tooltip: v => (v ? i18n.t('created_by') : null)
                }
            }),
            this.createHeader('created_by_email', i18n.t('user_email'), {
                width: '14rem',
                transform: data => data.item?.created_by?.email,
                classList: ['text--secondary', 'text--small'],
                filterable: true
            })
        ];
    }
}

export default ActivityInvestorFlowCollection;
